// @flow
import type {
  CommentOperator,
} from '../types'

// Constants
import {
  MODEL,
} from 'hfty-model-comments'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: CommentOperator = composeOperator({
  model: MODEL,
})

export default operator
